<template lang="pug">

  MDashboardWidget( title="Audits selected by BatchId" )

    div(class="form-group row")

        div(class="col-sm-10")
          label Batch Id
          p It is possible to submit multiple batch IDs separated by commas eg: "batch1,batch2,batch3"
          input(type="text" placeholder="Enter Batch ID" class="form-control" v-model="batchIds") 

        div(class="col-sm-12 mt-3")
          button(
            class="btn btn-details btn-outline btn-info mr-2"
            v-for="report in availableReports"
            v-if="! report.guard || report.guard()"
            v-bind:disabled="report.disabled || !batchIds || loading"
            v-on:click="generateCSV(report.type)"
          )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            MMoonpullIcon( v-if="report.su" class="mr-2" )
            | {{ report.name }}

          p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}
    
</template>
<style lang="scss" scoped></style>

<script>
import dateFormat from "dateformat";
import gql from "graphql-tag";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      batchIds: "",
      loading: false,
      errorMessage: "",
      availableReports: [
        {
          name: "Publisher Report",
          type: "publisher",
        },
        {
          name: "Publisher Report - Advertiser history (by country)",
          type: "publisher-with-previous-audits",
          guard: () =>
            this.$moonpull.currentUserHasAccessTo(
              "publisherReportWithAdvertiser"
            ),
        },
        {
          name: "Network Report (AWIN)",
          type: "network-standard-awin",
          guard: () =>
            this.$moonpull.currentUserCompanyIs("Awin") ||
            this.$moonpull.currentUserIsSuperAdmin(),
        },
        {
          name: "Network Report (Impact)",
          type: "network-standard-impact",
          guard: () =>
            this.$moonpull.currentUserCompanyIs("impact.com") ||
            this.$moonpull.currentUserIsSuperAdmin(),
        },
      ],
    };
  },
  methods: {
    myMethod() {
      console.log("do something");
    },

    async generateCSV(type) {
      this.loading = true;
      try {
        let csv;
        if (type === "client-standard-old") {
          const {
            data: { generateCsvFromBatchIds: csvData },
          } = await this.$apollo.query({
            query: gql`
              query GenerateClientReport($batchIds: [ID!]!) {
                generateCsvFromBatchIds(batchIds: $batchIds)
              }
            `,
            variables: {
              batchIds: this.batchIds.split(","),
            },
          });
          csv = csvData;
        } else {
          const {
            data: { generateClientReport: csvData },
          } = await this.$apollo.query({
            query: gql`
              query GenerateClientReport($batchIds: [ID!]!, $type: String!) {
                generateClientReport(batchIds: $batchIds, type: $type)
              }
            `,
            variables: {
              batchIds: this.batchIds.split(","),
              type,
            },
          });
          csv = csvData;
        }
        this.$moonpull.downloadCsv(
          csv,
          `report-${type}-${dateFormat(new Date(), "yyyy-mm-dd_HH_MM")}.csv`
        );
      } catch (e) {
        this.errorMessage = `Error downloading report`;
      }

      this.loading = false;
    },
  },
});
</script>
